import React from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'

import Text from 'components/_new/typography/Text/Text'
import Box from 'components/_new/layout/Box/Box'

import messages from './messages'
import s from './Orders.scss'

import billImage from './images/bill.svg'


const Orders = (props) => {
  const { isEcommerceErrorExist, ecommerceOrderNumber, subscriptionOrderNumber, billingPeriod } = props

  return (
    <div className={s.orders}>
      {
        Boolean(!isEcommerceErrorExist && ecommerceOrderNumber) && (
          <Box
            className={s.order}
            p="16"
            dataTestId={constants.testIds.thankYouPage.orderBill}
          >
            <Box mr="16">
              <img src={billImage} className={s.billImage} alt="" />
            </Box>
            <div>
              <Text color="gray" message={messages.ecommerceOrder} />
              <div>
                <Text message={messages.order} tag="span" color="gray" />: #{ecommerceOrderNumber}
              </div>
            </div>
          </Box>
        )
      }
      {
        Boolean(!isEcommerceErrorExist && subscriptionOrderNumber) && (
          <Box
            className={s.order}
            p="16"
            dataTestId={constants.testIds.thankYouPage.subscriptionBill}
          >
            <Box mr="16">
              <img src={billImage} className={s.billImage} alt="" />
            </Box>
            <div>
              <Text color="gray" message={messages.subscriptionOrder} tag="span" />
              <Box mt="8">
                <Text message={messages.plan} tag="span" color="gray" />:&nbsp;
                <Text message={messages.subscriptionPlan} values={{ billingPeriod }} tag="span" />
              </Box>
              <Box mt="8">
                <Text message={messages.order} tag="span" color="gray" />: #{subscriptionOrderNumber}
              </Box>
            </div>
          </Box>
        )
      }
      {
        isEcommerceErrorExist && (
          <Box
            className={s.order}
            p="16"
            dataTestId={constants.testIds.thankYouPage.orderError}
          >
            <Box mr="16">
              <img src={billImage} className={s.billImage} alt="" />
            </Box>
            <div>
              <Text color="gray" message={messages.ecommerceOrder} tag="span" />
              <Text message={messages.order} tag="span" color="gray" />: <Text message={messages.error} tag="span" />
            </div>
          </Box>
        )
      }
    </div>
  )
}

Orders.propTypes = {
  isEcommerceErrorExist: PropTypes.bool,
  ecommerceOrderNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  subscriptionOrderNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  billingPeriod: PropTypes.number,
}


export default Orders
